import React from 'react';
import { Typography, Divider } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  returnDetailMsg,
  returnFlightsHs,
} from '@shared/helpers/flights/acordeon';

const RenderDetailScales = ({ object_option }) => {
  return (
    <>
      <Typography
        color="inherit"
        sx={{
          fontWeight: {
            xs: 400,
            sm: 600,
          },
          whiteSpace: 'nowrap',
          fontSize: '14px',
          textAlign: 'center',
          lineHeight: 1,
        }}
      >
        Detalle de escalas
      </Typography>

      <Divider sx={{ m: '5px' }} />

      {object_option.flights.length === 1 ? (
        <>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
            Vuelo sin escalas!
          </Typography>
          <Typography
            variant="caption"
            color="error"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {returnFlightsHs(object_option)}
          </Typography>
        </>
      ) : (
        <>
          {object_option.flights.map((flight, flightIndex) => {
            if (flightIndex + 1 === object_option.flights.length) return null;

            const segments = returnDetailMsg(flight).split(
              'Cambio de aeropuerto - Traslado no incluido'
            );

            return (
              <Typography
                variant="body2"
                sx={{
                  mt: 0.875,
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
                key={`flight-${flightIndex}`}
              >
                {segments.map((segment, idx) => {
                  const key = `flight-${flightIndex}-seg-${idx}`;
                  if (idx < segments.length - 1) {
                    return (
                      <React.Fragment key={key}>
                        {segment}
                        <span style={{ color: 'red' }}>
                          Cambio de aeropuerto - Traslado no incluido
                          <ErrorOutlineIcon
                            fontSize="small"
                            sx={{ color: 'red', pt: 0.625 }}
                          />
                        </span>
                      </React.Fragment>
                    );
                  }
                  return <span key={key}>{segment}</span>;
                })}
              </Typography>
            );
          })}

          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.875, whiteSpace: 'nowrap' }}
          >
            {returnFlightsHs(object_option)}
          </Typography>
        </>
      )}
    </>
  );
};

export default RenderDetailScales;
